/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationEmailCreate
 */
export interface NotificationEmailCreate {
    /**
     * 
     * @type {string}
     * @memberof NotificationEmailCreate
     */
    email: string;
}

/**
 * Check if a given object implements the NotificationEmailCreate interface.
 */
export function instanceOfNotificationEmailCreate(value: object): value is NotificationEmailCreate {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function NotificationEmailCreateFromJSON(json: any): NotificationEmailCreate {
    return NotificationEmailCreateFromJSONTyped(json, false);
}

export function NotificationEmailCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationEmailCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function NotificationEmailCreateToJSON(json: any): NotificationEmailCreate {
    return NotificationEmailCreateToJSONTyped(json, false);
}

export function NotificationEmailCreateToJSONTyped(value?: NotificationEmailCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

